type BaseResultData<TData> = {
	results: TData[];
	startIndex: number;
	size: number;
};

// Return anything but false to indicate that there is more to fetch
// The return here is not anything we are actually using - but we are relying
// on this to report there is more to be fetched
// What we pass back from here would be sent automatically when we call
// `getDownloadRequestApprovalsQuery.fetchNextPage()` without any arguments
export const getReactQueryNextPageParam = <TData>(
	lastPage: BaseResultData<TData>,
	pages: BaseResultData<TData>[],
) => {
	if (!lastPage) return false;
	const {startIndex, size, results} = lastPage;

	const totalItemsFetched =
		pages?.reduce((accum, current) => accum + current.results.length, 0) || 0;

	// Are there more items to fetch
	return totalItemsFetched < size
		? {
				startIndex: startIndex + results.length,
				stopIndex: startIndex + results.length + results.length,
		  }
		: false;
};

export default getReactQueryNextPageParam;
